<template>
  <div>
    <main>
      <section class="home">
        <div class="version">v.{{ version }}</div>
        <div @click="scrollController" class="brand">Theo<span>'</span>s</div>
        <div class="brand-text"><span>Vue</span> playground</div>
        <input type="checkbox" class="contact-toggle" id="contact-toggle" />
        <div class="contact-menu">
          <ul>
            <li><a href="https://theoz.dev" target="_blank">Web Page</a></li>
            <li>
              <a
                href="https://github.com/ghrqq"
                rel="noreferrer"
                target="_blank"
                >GitHub</a
              >
            </li>
            <li>
              <a
                href="https://bitbucket.org/theooz/"
                target="_blank"
                rel="noreferrer"
              >
                BitBucket</a
              >
            </li>
            <li disabled>Discord</li>
            <li>
              <a href="mailto:theoozdev@gmail.com" target="_blank">Mail</a>
            </li>
          </ul>
          <label class="toggle-button" for="contact-toggle"> x </label>
        </div>
        <div class="menu-container">
          <label for="contact-toggle">
            <div id="contact" class="menu-item">Contact</div>
          </label>
          <a href="#discover" id="discover-text" class="menu-item">
            <span>Discover</span>
          </a>
          <router-link to="/about" id="about" class="menu-item"
            >About Me</router-link
          >
        </div>
      </section>
      <section class="discover" id="discover">
        <Discover />
      </section>
    </main>
  </div>
</template>
<script>
import { defineComponent, ref, onMounted } from 'vue';
import Discover from '../components/Discover.vue';

export default defineComponent({
  name: 'Home-View',
  components: { Discover },
  setup() {
    const version = ref('');

    onMounted(() => {
      // version.value = process?.env?.VUE_APP_VERSION; // TODO: Fix process.env
      version.value = '0.1.1';
    });

    return {
      version,
    };
  },
});
</script>
<!-- https://huemint.com/brand-intersection/#palette=fffbf7-1b47a4-f14998-0bbde6 -->

<style scoped>
main {
  height: auto;
}
.contact-menu {
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  text-align: left;
  top: 0;
  left: 0;
  height: 100vh;
  width: 50%;
  background: #2c3e50;
  transform: scale(0, 1);
  transform-origin: left;
  transition: transform 400ms ease-in-out;
  z-index: 999;
  padding: 0 0.3rem;
  color: rgb(11, 189, 230);
}
.contact-menu ul {
  list-style: none;
  padding: 0;
  margin: 2rem auto;
  width: 100%;
}
.contact-menu a {
  text-decoration: none;
  color: rgb(11, 189, 230);
}
.contact-menu li {
  font-size: 1rem;
  text-transform: uppercase;
  padding: 0.3rem;
  font-weight: 600;
  opacity: 0;
  transition: opacity 150ms ease-in-out;
  cursor: pointer;
}
.contact-menu li:hover,
.contact-menu a:hover {
  color: cyan;
}

.toggle-button {
  cursor: pointer;
  padding: 0.3rem;
  font-weight: 600;
  font-size: 2rem;
  margin: 1rem auto;
  padding: 1rem;
  border-radius: 100%;
}
.toggle-button:hover {
  color: cyan;
  transition: color 0.5s ease-in-out;
  box-shadow: cyan 2px 5px 5px;
  transition: box-shadow 0.5s ease-in-out;
  transform-origin: left;
}

.contact-toggle:checked ~ .contact-menu {
  transform: scale(1, 1);
}
.contact-toggle:checked ~ .contact-menu li {
  opacity: 1;
  transition: opacity 250ms ease-in-out 250ms;
}

#contact-toggle {
  display: none;
}
.home {
  background: rgb(11, 189, 230);
  background: radial-gradient(
    circle,
    rgba(11, 189, 230, 1) 0%,
    rgba(27, 71, 164, 1) 100%
  );
  height: 100vh;
  width: 100vw;
  margin: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.brand {
  font-size: 3rem;
  font-weight: 900;
  cursor: default;
  user-select: none;
}
.brand-text {
  font-size: 1rem;
  font-weight: 700;
  cursor: default;
  user-select: none;
}
.brand span,
.brand-text span {
  color: #f14998;
}
.brand-text span:last-of-type {
  color: #f14998;
  background: #2c3e50;
  padding: 5px 10px;
  border-radius: 5px;
}
.brand-text span:last-of-type:hover {
  color: #42b983;
  background: #2c3e50;
  padding: 5px 10px;
  border-radius: 5px;
  transition: color 0.5s ease-in-out;
}
.brand-text::after {
  content: '.';
  animation: jumping-items 1s infinite alternate;
}
@keyframes jumping-items {
  33% {
    color: #42b983;
  }
  66% {
    color: #f14998;
  }
  100% {
    color: #2c3e50;
  }
}

.version {
  display: block;
  position: absolute;
  top: 1rem;
  right: 1rem;
  font-size: 0.8rem;
  font-weight: 800;
}

.menu-item {
  display: block;
  font-size: 1rem;
  position: absolute;
  font-weight: 700;
  color: #2c3e50;
  text-transform: uppercase;
}
#contact {
  left: 0.3rem;
  top: 50%;
  transform: rotate(90deg);
  cursor: pointer;
}
#discover-text {
  bottom: 1rem;
  left: 0;
  right: 0;
  margin: 0 auto;
}
#about {
  right: 0.3rem;
  top: 50%;
  transform: rotate(-90deg);
  text-decoration: none;
}
.menu-item:hover {
  color: #f14998;
  transition: color 0.5s ease-in-out;
}
.menu-container a {
  text-decoration: none;
  cursor: pointer;
}

#discover {
  min-height: 100vh;
  width: 100vw;
  background: rgb(27, 71, 164);
  background: linear-gradient(
    184deg,
    rgba(27, 71, 164, 1) 0%,
    rgba(11, 189, 230, 1) 100%
  );
}

@media screen and (min-width: 600px) {
  .brand {
    font-size: 4rem;
  }
  .brand-text {
    font-size: 2rem;
  }
  .menu-item {
    font-size: 2rem;
  }
  .contact-menu {
    width: 25%;
  }
}
</style>
